import {
  FAQS,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  ADD_ON_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const sacramentokings_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "sacramentokings_upgrades",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Sacramento Kings Upgrades",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#63727A",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: false,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    DEFAULT_APP_ROUTE: routes.landing,

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/sackings/",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    HIDE_PASSES: true,

    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Desktop%201920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Mobile%20375x550.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Desktop%201920x450.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/kings-v3-assets/BACKGROUND IMAGE_1.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
